// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"44dcad2c","134":"7de94d87","310":"fc3b8e92","806":"781ee28f","937":"9a3cdc7b","970":"83ad453c"}[chunkId] + ".chunk.css";
};